import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
};

export const getProjects = createQueryFn(
  QueryNameSpace.getProjects,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params], string[]>) => {
    const [, params] = queryKey;

    const res = await DigiobcanApi.getProjects({
      ...params,
      pagecursor: pageParam,
    });

    return res.projects;
  },
);
